import { GetPresignedUrlsResponse } from '../media.types';

export const createPresignedUrls = (
  keys: string[],
): GetPresignedUrlsResponse => ({
  presignedUrls: keys.map(key => ({
    key,
    /*
     * Built from the key rather than fixed, so a mocked upload behaves like a
     * real one: two uploads are told apart, and the stored url keeps the file's
     * own name and extension. A fixed .jpg made every video resolve to an image
     * name, which reads as a bug in the feature rather than in the fixture.
     */
    presignedUrl: `https://mock.s3.us-east-1.amazonaws.com/${key}?sig=mock`,
  })),
});
